import styled from 'styled-components'

export const CreationContentContainer = styled.div.withConfig<{ subHeader: boolean }>({
	shouldForwardProp: prop => !['subHeader'].includes(prop)
})`
	width: 100%;
	padding-top: ${props => (props.subHeader ? 0 : '15px')};
	padding-bottom: 40px;
`
